exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.required-asterisk[data-v-dbe03d98] {\n    color: red;\n}\n", ""]);

// exports
